<template>
  <div class="flex flex_between">
    <md-field :class="[{ 'md-error': error }]">
      <label>{{ label }}</label>
      <TbSelect v-model="moduleValue"
                @md-selected="onSelect"
                content-size="large"
                :search-allow="true"
                :options="options"
                options-value-field="selectId"
                options-display-field="displayValue"
                :required="required"
                class="hide-dropdown-icon"
      />
      <span v-if="error" class="validation-error">{{ error }}</span>
    </md-field>
    <template v-if="showAdd">
      <div class="icon_box flex_end flex_column" @click="showDetail">
        <i
            class="fa fa-pencil-square-o font_lg"
            :class="debtorData&&debtorData.name?'':'disabled_icon'"
            aria-hidden="true"
        ></i>
      </div>
    </template>
  </div>
</template>
<script>
import {mapGetters} from "vuex";

import {debtorManagementApi} from "src/common/api/debtorManagementApi";

export default {
  props: {
    labelText: {type: String, default: "seller.upload.DebtorContact"},
    error: {type: Boolean, default: ""},
    required: {type: Boolean, default: false},
    value: {type: [String, Object], default: null},
    showAdd: {type: Boolean, default: true}
  },
  data() {
    return {
      moduleValue: "",
      searchValue: "",
      options: [],
      hasList: [],
      activeData: null
    };
  },
  mounted() {
    this.changeOption();
  },
  methods: {
    getList(id) {
        debtorManagementApi
          .inspection.debtorContact(id)
          .then(res => {
            this.options = [];
            this.hasList = [];
            res.forEach(item => {
              this.options.push({
                ...item,
                selectId: this.getSelectId(item),
                displayValue: this.getDisplayValue(item)
              });
            });
            this.hasList = [...this.options];
          })
          .catch(() => {
          });
    },
    reset() {
      this.moduleValue = "";
      this.options = [];
      this.searchValue = "";
      this.$emit("input", null);
    },
    addDebtor() {
      if (this.debtorData && this.debtorData.name) {
        this.$store.dispatch("setActionNoticModal", {
          show: true,
          data: {
            type: "ContactModal",
            data: {},
            subFun: this.subFun
          }
        });
      }
    },
    subFun(data) {
      this.moduleValue = this.getSelectId(data);
      this.activeData = data;
      this.$store.dispatch("setActionContactData", data);
    },
    onSelect() {
      this.options.forEach(item => {
        if (item.selectId === this.moduleValue) {
          this.activeData = item;
        }
      });
      this.$emit("input", this.activeData);
    },
    changeOption() {
      this.options = [...this.hasList];
      this.moduleValue = "";
      if (this.value) {
        if (!this.value.id) {
          this.options.push({
            ...this.value,
            selectId: this.getSelectId(this.value),
            displayValue: this.getDisplayValue(this.value)
          });
        }
        this.moduleValue = this.getSelectId(this.value);
      } else {
        this.moduleValue = "";
      }
    },
    showDetail() {
      if (this.moduleValue) {
        this.$store.dispatch("setActionNoticModal", {
          show: true,
          data: {
            type: "ContactModal",
            data: this.activeData,
            subFun: this.subFun,
            readOnly: true
          }
        });
      } else {
        this.addDebtor();
      }
    },
    getSelectId(data) {
      return data.name + " (" + data.email + " - " + data.phone + ")";
    },
    getDisplayValue(data) {
      return data.name + " (" + data.email + ")";
    }
  },
  computed: {
    ...mapGetters({debtorData: "debtorData", contactData: "contactData"}),
    label() {
      return this.$t(this.labelText);
    }
  },
  watch: {
    debtorData: {
      handler() {
        if (this.debtorData && this.debtorData.id) {
          this.getList(this.debtorData.id);
        }
        if (!this.debtorData && this.contactData) {
          this.reset();
        }
      },
      deep: true
    },
    value() {
      this.changeOption();
      this.activeData = this.contactData;
    }
  }
};
</script>